import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import Confirm from "./Confirm";
import Success from "./Success";
import { AppContext } from "../../../lib/Context";

// Step titles
const labels = ["Information", "Payment", "Confirmation"];

const handleSteps = (step, courseDetails) => {
  switch (step) {
    case 0:
      return <FirstStep courseDetails={courseDetails} />;
    case 1:
      return <SecondStep courseDetails={courseDetails} />;
    case 2:
      return <Confirm courseDetails={courseDetails} />;
    default:
      throw new Error("Unknown step");
  }
};

export default function StepForm({ courseDetails }) {
  const { activeStep } = useContext(AppContext);
  console.log(courseDetails);
  return (
    <>
      {activeStep === labels.length ? (
        <Success />
      ) : (
        <>
          <Box sx={{ my: 5 }}>
            <Typography variant="h4" align="center">
              Multi Step Form
            </Typography>
            <Typography variant="subtitle2" align="center" sx={{ mt: 2 }}>
              React Material UI multi step form with basic form validation
              logic.
            </Typography>
          </Box>
          <Stepper activeStep={activeStep} sx={{ py: 3 }} alternativeLabel>
            {labels.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {handleSteps(activeStep, courseDetails)}
        </>
      )}
    </>
  );
}
